import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import { ICON_TYPE_PROP_TYPE, ICON_SIZE_PROP_TYPE } from '../icon/constants';
import { PAYMENT_TYPE_PROP_TYPE, PAYMENT_SIZE_PROP_TYPE } from '../paymentIcon/constants';
import { TYPES as BUTTON_TYPES } from '../button/constants';
export var TEXT_ITEM_PROP_TYPE_SHAPE = PropTypes.shape({
  value: PropTypes.string.isRequired,
  buttonType: PropTypes.oneOf(BUTTON_TYPES),
  content: PropTypes.node,
  iconType: PropTypes.oneOfType([ICON_TYPE_PROP_TYPE, PAYMENT_TYPE_PROP_TYPE]),
  iconSize: PropTypes.oneOfType([ICON_SIZE_PROP_TYPE, PAYMENT_SIZE_PROP_TYPE]),
  imageAlt: EBPropTypes.translation,
  imageUrl: PropTypes.string,
  isSquareImage: PropTypes.bool,
  path: PropTypes.string,
  renderContainer: PropTypes.func,
  secondaryContent: EBPropTypes.translation,
  showDivider: PropTypes.bool,
  dividerVertSpacing: PropTypes.integer,
  tertiaryContent: EBPropTypes.translation
});
export var TEXT_ITEMS_PROP_TYPE = PropTypes.arrayOf(TEXT_ITEM_PROP_TYPE_SHAPE);
export var TEXT_ITEMS_CHARACTER_LENGTH_MAP = {
  secondary: 88,
  tertiary: 88
};